// extracted by mini-css-extract-plugin
export default {"dark":"styles_dark__AzlWN","container":"styles_container__U0fd7","appPlay":"styles_appPlay__OKLui"};